import axios from "axios";
import { baseURL } from "../baseURL";

/**
 * API service for fetching innovator data from backend
 */

/**
 * Get all companies/innovators
 * @returns {Promise<Object>} GeoJSON FeatureCollection
 */
export const getInnovators = async () => {
  try {
    const response = await axios.get(`${baseURL}/api/innovators`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching innovators:", error);
    throw error;
  }
};

/**
 * Get relationships between companies
 * @param {string} filterType - Optional relationship type filter
 * @returns {Promise<Object>} GeoJSON FeatureCollection with relationship arcs
 */
export const getRelationships = async (filterType = null) => {
  try {
    const params = filterType && filterType !== "all" ? { relationshipType: filterType } : {};
    const response = await axios.get(`${baseURL}/api/innovators/relationships`, {
      params,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching relationships:", error);
    throw error;
  }
};

/**
 * Get all available relationship types
 * @returns {Promise<Array>} Array of relationship type objects
 */
export const getRelationshipTypes = async () => {
  try {
    const response = await axios.get(`${baseURL}/api/innovators/relationship-types`, {
      withCredentials: true,
    });
    return response.data.relationship_types || [];
  } catch (error) {
    console.error("Error fetching relationship types:", error);
    throw error;
  }
};

